import gql from 'graphql-tag'

export const productsQuery = gql`
  query (
    $after: String, 
    $tasteProfile: String!,
    $tasteType: String!,
    $acidity: Int!,
    $complexity: Int!,
    $intensity: Int!,
    $sweetness: Int!,
    $tannin: Int!,
    $minPrice: Float,
    $maxPrice: Float,
    $limit: Int,
    $orderBy: String = "tasteProfileMatch",
    $availability: String,
    $countrySlug: [String],
  ) {
    products(
      first: $limit,
      where: {
        countrySlug_In: $countrySlug,
        tasteProfile: $tasteProfile,
        sortPrice_Gte: $minPrice,
        sortPrice_Lte: $maxPrice,
        availability: $availability,
        wineColor_Lte: 2 # Only display red (1) and white (2) wines. This excludes rose (3) wines.
      },
      after: $after, 
      userTasteProfile: {
        tasteType: $tasteType, 
        acidity: $acidity,
        complexity: $complexity,
        intensity: $intensity,
        sweetness: $sweetness,
        tannin: $tannin
      }
      orderBy: $orderBy
    ) {
      pageInfo {
        hasPreviousPage
        hasNextPage
        startCursor
        endCursor
      }
      edges {
        node {
          countrySlug
          absoluteUrl
          availability
          availableAsPackage {
            uom
            qos
          }
          category
          isArticle
          isAvailableAsItem
          isBeverage
          imageUrls {
            medium
          }
          price {
            retail
            discounted
            discountedLoyalty
          }
          sku
          sticker {
            title
            text
          }
          tasteProfileMatch
          title
        }
      }
      totalCount
    }
  }
`
